import styled from 'styled-components'
import breakpoint from '@/client/components/theme/breakpoint'
import color from '@/client/components/theme/color'
import space from '@/client/components/theme/space'

export const ResultConatiner = styled.div`
  margin-top: ${space.xl};
`

export const Box = styled.div`
  width: 100%;
  background-color: ${color.grayscale.lighter};
  border-radius: ${space.md};
  padding: ${space.lg};
`

export const LabelInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: ${space.lg};

  @media (min-width: ${breakpoint.lg2}) {
    flex-direction: row;
    margin-bottom: 0;
  }
`

export const InfoWrapper = styled.div`
  width: 100%;

  @media (min-width: ${breakpoint.lg2}) {
    width: 65%;
  }
`

export const MaterialInfoWrapper = styled.div`
  width: 100%;

  @media (min-width: ${breakpoint.lg2}) {
    width: 45%;
  }

  @media (min-width: ${breakpoint.xl2}) {
    width: 35%;
  }
`

export const MaterialInfo = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 0.5fr 1fr;
  & > *:nth-child(3n) {
    grid-column: 1 / -1; /* Span every third item across all columns */
  }
  column-gap: ${space.sm};
`
export const Sections = styled.div`
  width: 50%;
`

export const IconWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  &.dots-icon {
    width: 50%;
  }

  &.temperature {
    width: 90%;
  }

  @media (min-width: ${breakpoint.lg}) {
    &.recycle {
      width: 70%;
    }

    &.dots-icon {
      width: 23%;
    }

    &.temperature {
      width: 50%;
    }
  }
`

export const Divider = styled.div`
  height: 1px;
  background-color: ${color.grayscale.headerGray};
  width: 100%;
  margin: ${space.xs} 0;
`

export const ButtonWrapper = styled.div`
  margin-top: ${space.xl2};
  display: flex;
  gap: ${space.xs};
  flex-direction: column;

  .icon-artwork-pdf:before {
    color: #8a9099 !important;
  }

  @media (min-width: ${breakpoint.lg}) {
    gap: ${space.lg};
    justify-content: flex-end;
    flex-direction: row;
  }
`
